import PortalLoader, { PortalOverlayLoader, PortalPageFallback, PortalSectionFallback } from "./PortalLoader";

/** Dashboard portals: fullScreen route fallbacks, section blocks, optional inline. */
export default function Loader({
  fullScreen = false,
  message,
  text,
  submessage = "",
  inline = false,
  className = "",
}) {
  const msg = message || text || "Loading";
  if (fullScreen) {
    return <PortalPageFallback message={msg} submessage={submessage} className={className} />;
  }
  if (inline) {
    return <PortalLoader variant="inline" message={msg} submessage={submessage} className={className} />;
  }
  return <PortalLoader variant="section" message={msg} submessage={submessage} className={className} />;
}

export { PortalLoader, PortalPageFallback, PortalSectionFallback, PortalOverlayLoader };
